module.exports = __webpack_public_path__ + "static/media/Portrait-10200.b93d89c0.jpg";